module.exports = __webpack_public_path__ + "assets/img/icon_whale_2x.5faeb1d2.png";